import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { TableView, getTableConversationRelation } from 'owa-mail-list-store';
import ItemId from 'owa-service/lib/contract/ItemId';

export interface ItemContext {
    itemId: string;
    itemConversationId: ItemId;
    isRead: boolean;
}

/**
 * Updates folder count while moving items from primary to archive mailbox
 * @param itemContexts contains isRead information about the items being moved
 * @param destinationFolderId folder id whose count has to be updated
 */
function updateCountForItemMove(itemContexts: ItemContext[], destinationFolderId: string) {
    const unreadCountChange = itemContexts.filter(itemContext => !itemContext.isRead).length;
    const totalCountChange = itemContexts.length;
    updateFolderCounts(unreadCountChange, totalCountChange, destinationFolderId, true);
}

/**
 * Updates folder count while moving a conversation from primary to archive
 * @param rowKeys row keys of the items in the conversation
 * @param originalTableView tableview of the source folder to calculate unread and total item count
 * @param destinationFolderId folder id whose count has to be updated
 */
function updateCountForConversationMove(
    rowKeys: string[],
    originalTableView: TableView,
    destinationFolderId: string
) {
    let totalUnreadCount = 0;
    let totalCount = 0;
    rowKeys.forEach(rowKey => {
        const tableConversationRelation = getTableConversationRelation(
            rowKey,
            originalTableView.id
        );
        totalUnreadCount += tableConversationRelation.unreadCount;
        totalCount += tableConversationRelation.itemIds.length;
    });
    updateFolderCounts(
        totalUnreadCount /* unreadCount */,
        totalCount /* totalCount */,
        destinationFolderId /* folderId */,
        true /* isDeltaChange */
    );
}

export { updateCountForItemMove, updateCountForConversationMove };
